import { Typography } from "@mui/material"
import { Grid } from "@mui/material"

export function NotFound() {
    return (
        <div>
            <Grid item gap={3} sx={{ mt: 3, height: '100vh' }}>
                <Typography variant="h1" component="h2" textAlign='center'>
                    404 Not Found
                </Typography>
                <Typography variant="h3" component="div" textAlign='center'>
                    このページは存在しないか、既に削除されています。
                </Typography>
            </Grid>
        </div>
    )
}